import { Mark, Schema } from 'prosemirror-model';
import { isElement } from '../../utils/html';
import { markSpecGenerator } from '../../utils/proseMirror';
export const schemaMarkAttrs = [
  'font-family',
  'font-weight',
  'font-style',
  'font-size',
  'color',
  'line-height'
];
export const schemaParagraphAttrs = ['text-align'];
export const schemaAttrs = schemaMarkAttrs.concat(schemaParagraphAttrs);

export const defaultMarkValues = {
  'font-family': 'open-sans',
  'font-weight': '300',
  'font-style': 'normal',
  'font-size': 15,
  color: '#333333',
  'line-height': '1.17'
};
export const defaultParagraphValues = { 'text-align': 'left' };

function generator(scale: number, allowMultipleLines, defaultAlignment) {
  const numberConverters = {
    encode: function (e) {
      return parseInt(e.toString(), 10) * scale + 'px';
    },
    decode: function (e) {
      return parseInt(e, 10);
    }
  };
  const stringConverters = {
    encode: function (e) {
      return e.toString();
    },
    decode: function (e) {
      return e;
    }
  };

  const schema = new Schema({
    nodes: {
      doc: {
        content: allowMultipleLines ? 'paragraph+' : 'paragraph'
      },
      paragraph: {
        attrs: {
          marks: {
            default: null
          },
          'text-align': {
            default: defaultAlignment || null
          }
        },
        content: 'text*',
        toDOM: function (e) {
          const marksFromAttr = e.attrs.marks;
          let markData = '';

          [
            ['font-family', stringConverters],
            ['font-weight', stringConverters],
            ['font-style', stringConverters],
            ['line-height', stringConverters],
            ['color', stringConverters],
            ['font-size', numberConverters],
            ['text-align', stringConverters],
            ['variable', stringConverters]
          ].forEach(function (markPair) {
            var markName = markPair[0];
            var markConverter = markPair[1];

            if (marksFromAttr && marksFromAttr[markName] != null) {
              markData +=
                markName +
                ': ' +
                markConverter.encode(marksFromAttr[markName]) +
                '; ';
            }

            if (e.attrs[markName] != null) {
              markData +=
                markName +
                ': ' +
                markConverter.encode(e.attrs[markName]) +
                '; ';
            }
          });

          return [
            'p',
            {
              style: markData,
              'data-marks': marksFromAttr ? JSON.stringify(marksFromAttr) : ''
            },
            0
          ];
        },
        parseDOM: [
          {
            tag: 'p',
            getAttrs: function (e) {
              if (e instanceof Node && isElement(e)) {
                const domAttrMarks = e.getAttribute('data-marks');
                const alignment = e.getAttribute('text-align');

                return {
                  marks: domAttrMarks ? JSON.parse(domAttrMarks) : null,
                  'text-align': alignment
                };
              }
            },
            preserveWhitespace: true
          }
        ]
      },
      text: {
        group: 'inline',
        parseDOM: [
          {
            preserveWhitespace: true
          }
        ],
        toDOM: function (node) {
          return node.text;
        }
      }
    },
    marks: {
      'font-size': markSpecGenerator('font-size', numberConverters),
      'font-family': markSpecGenerator('font-family', stringConverters),
      'font-weight': markSpecGenerator('font-weight', stringConverters),
      'font-style': markSpecGenerator('font-style', stringConverters),
      color: markSpecGenerator('color', stringConverters),
      variable: markSpecGenerator('variable', stringConverters),
      'line-height': markSpecGenerator('line-height', stringConverters)
    }
  });

  return schema;
}

function TextSchema(
  scale: number,
  allowMultipleLines: boolean,
  defaultAlignment: string
) {
  if (scale === 0) scale = 1;

  const schema = generator(scale, allowMultipleLines, defaultAlignment);
  schema.newlyMeta = { scale, allowMultipleLines, defaultAlignment };

  return schema;
}

export default TextSchema;
